/* global $, query_string, leaderboard_data, show_bat_tracking */
import table from 'bam-node-savant-table/table'

let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'prLeaderboard'

$(() => {
    $('#btnUpdate').click(() => {
        window.location.href = `/leaderboard/percentile-rankings?type=${$(
            '#ddlType'
        ).val()}&year=${$('#ddlSeason').val()}&team=${$('#ddlTeamId').val()}`
    })

    $('#btnCSV').click(() => {
        window.location.href = `/leaderboard/percentile-rankings?type=${$(
            '#ddlType'
        ).val()}&year=${$('#ddlSeason').val()}&team=${$(
            '#ddlTeamId'
        ).val()}&csv=true`
    })
})

$(document).ready(() => {
    $('form').submit(false)
    $('#ddlTeamId').change(() => {
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    })
    $('#ddlPosition').change(() => {
        $('#lblPosition').html($('#ddlPosition option:selected').text())
    })

    $('#ddlSeason').change(() => {
        $('#lblSeason').html($('#ddlSeason').val())
    })
    $('#ddlMin').change(() => {
        $('#lblMin').html(
            `Minimum BBE (${$('#ddlMin option:selected').text()})`
        )
    })
    $('#ddlType').change(() => {
        $('#lblType').html($('#ddlType option:selected').text())
    })

    if (query_string.type) {
        if (query_string.type.indexOf('team') > -1) {
            $('#team-ddl').hide()
        }
        $('#ddlType').val(query_string.type).attr('selected', true)
        $('#lblType').html($('#ddlType option:selected').text())
    }
    if (query_string.min) {
        $('#ddlMin').val(query_string.min).attr('selected', true)
        $('#lblMin').html(
            `Minimum BBE (${$('#ddlMin option:selected').text()})`
        )
    }

    if (query_string.year) {
        $('#ddlSeason').val(query_string.year).attr('selected', true)
        $('#lblSeason').html($('#ddlSeason').val())
    }

    if (query_string.position) {
        $('#ddlPosition').val(query_string.position).attr('selected', true)
        $('#lblPosition').html($('#ddlPosition option:selected').text())
    }

    if (query_string.team) {
        $('#ddlTeamId').val(query_string.team).attr('selected', true)
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    }
    if (query_string.sortDir) {
        $('#sortDir').val(query_string.sortDir)
    }

    if (query_string.sort) {
        $('#sort').val(query_string.sort)
    }

    if ($('#ddlType').val() === 'batter') {
        $('#positionGroup').show()
    }

    if (leaderboard_data && leaderboard_data.length > 0) {
        let headers = [
            {
                name: 'Player',
                field: 'href',
                customSortField: 'player_name',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                photoId: 'player_id',
            },
            {
                name: 'xwOBA',
                field: 'percent_rank_xwoba',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [1, 4, 7],
            },
            {
                name: 'xBA',
                field: 'percent_rank_xba',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [1, 4, 7],
            },
            {
                name: 'xSLG',
                field: 'percent_rank_xslg',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [1, 4, 7],
            },
            {
                name: 'xISO',
                field: 'percent_rank_xiso',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [1, 4, 7],
            },
            {
                name: 'xOBP',
                field: 'percent_rank_xobp',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [1, 4, 7],
            },

            {
                name: 'Brl',
                field: 'percent_rank_barrel',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [1, 4, 7],
            },
            {
                name: 'Brl%',
                field: 'percent_rank_barrel_batted_rate',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [1, 4, 7],
            },
            {
                name: 'EV',
                field: 'percent_rank_exit_velocity_avg',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [1, 4, 7],
            },
            {
                name: 'Max EV',
                field: 'percent_rank_exit_velocity_max',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [1, 4, 7],
            },
            {
                name: 'HardHit%',
                field: 'percent_rank_hard_hit_percent',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [1, 4, 7],
            },
            {
                name: 'K%',
                field: 'percent_rank_k_percent',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [1, 4, 7],
            },
            {
                name: 'BB%',
                field: 'percent_rank_bb_percent',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [1, 4, 7],
            },
            {
                name: 'Whiff%',
                field: 'percent_rank_whiff_percent',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [1, 4, 7],
            },
            {
                name: 'Chase%',
                field: 'percent_rank_chase_percent',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [1, 4, 7],
            },
        ]

        if ($('#ddlType').val().indexOf('batter') > -1) {
            headers.push({
                name: 'Speed',
                field: 'percent_speed_order',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [1, 4, 7],
            })

            headers.push({
                name: 'OAA',
                field: 'percent_rank_oaa',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [1, 4, 7],
            })
            headers.push({
                name: 'Arm <br/>Strength',
                field: 'percent_rank_arm_overall',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [1, 4, 7],
            })
        } else {
            headers.push({
                name: 'FB Vel.',
                field: 'percent_rank_fastball_velo',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [1, 4, 7],
            })
            headers.push({
                name: 'FB Spin',
                field: 'percent_rank_fastball_spin',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [1, 4, 7],
            })
            headers.push({
                name: 'Curve Spin',
                field: 'percent_rank_cu_spin',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [1, 4, 7],
            })
            headers.push({
                name: 'Extension',
                field: 'percent_rank_fastball_extension',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [1, 4, 7],
            })

            headers = headers.filter(
                (d) => d.field !== 'percent_rank_exit_velocity_max'
            )
        }

        if (show_bat_tracking) {
            headers.push(
                {
                    name: 'Bat<br/>Speed',
                    field: 'percent_rank_swing_speed',
                    type: 'number',
                    headerClass: 'th-component-header align-center',
                    fieldClass: 'tr-data align-center',
                    highlight: [1, 4, 7],
                },
                {
                    name: 'Squared-up<br/>Rate',
                    field: 'percent_rank_squared_up_swing',
                    type: 'number',
                    headerClass: 'th-component-header align-center',
                    fieldClass: 'tr-data align-center',
                    highlight: [1, 4, 7],
                },
                {
                    name: 'Swing<br/>Length',
                    field: 'percent_rank_swing_length',
                    type: 'number',
                    headerClass: 'th-component-header align-center',
                    fieldClass: 'tr-data align-center',
                    highlight: [1, 4, 7],
                }
            )
        }

        const width = $(`#${tableDivId}`).outerWidth()
        let repeatHeaders = false
        if (width <= 768) {
            repeatHeaders = 15
        }
        // eslint-disable-next-line no-new, new-cap
        new table({
            id: 'prLeaderboard',
            repeatHeader: repeatHeaders,
            headers,
            defaultSort:
                headers[Number($('#sort').val())].customSortField ||
                headers[Number($('#sort').val())].field,
            defaultSortDirection: $('#sortDir').val(),
            sortClass: 'column-sort',
            // PASS IN UNIQUE ROW ID... Use this for ajax calls
            subDataId: 'entity_id',
            showRank: true,
            data: leaderboard_data,
            highlightFalsy: false,
            highlightValFn: (val) =>
                // break into 5 equal parts
                Math.ceil((val + 13) / 18),
        })
    }

    $(document).on('click', 'th.th-component-header', function handleClick() {
        const id = this.id.split('-')[1]

        if (Number($('#sort').val()) === Number(id)) {
            if ($('#sortDir').val() === 'desc') {
                $('#sortDir').val('asc')
            } else {
                $('#sortDir').val('desc')
            }
        } else {
            $('#sortDir').val('desc')
        }
        $('#sort').val(id)
        isFixedHeaderShowing = false
        checkHeaderPosition(tableDivId)
        populateUrl()
    })

    window.addEventListener('scroll', () => {
        if (!ticking && leaderboard_data.length) {
            window.requestAnimationFrame(() => {
                checkHeaderPosition(tableDivId)
                ticking = false
            })

            ticking = true
        }
    })

    function checkHeaderPosition(divId) {
        const scrollPosY = window.scrollY
        const posTop = $(`#${divId}`).offset().top
        const height = $(`#${divId} table thead`).height()
        if (!isFixedHeaderShowing && posTop < scrollPosY) {
            isFixedHeaderShowing = true
            addStaticHeader(divId)
        } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
            $(`#${divId} table thead`).removeClass('fixed-header')
            isFixedHeaderShowing = false
        }
    }

    function addStaticHeader(divId) {
        const width = $(`#${divId}`).outerWidth()
        // $(".tr-component-row th").removeClass("column-sort");

        if (width && width > 767) {
            // console.log(width);
            let tableCell = 0

            // Set TH Width before applying fixed-header
            $('.default-table-row')
                .first()
                .children('td')
                .each(function handleEach() {
                    const eachWidth = $(this).outerWidth()
                    $(`.tr-component-row th:nth-child(${tableCell + 1})`).css(
                        'width',
                        eachWidth
                    )
                    tableCell += 1
                })

            $(`#${divId} table thead`).addClass('fixed-header')
            tableCell = 0

            // Set TD Width before applying fixed-header
            $('.tr-component-row')
                .children('th')
                .each(function handleEach() {
                    const eachWidth = $(this).outerWidth()
                    $(`.default-table-row td:nth-child(${tableCell + 1})`).css(
                        'width',
                        eachWidth
                    )
                    tableCell += 1
                })
        }
    }

    window.addEventListener('resize', () => {
        if (isFixedHeaderShowing) {
            addStaticHeader(tableDivId)
        }
    })

    function populateUrl() {
        const url = `/leaderboard/percentile-rankings?type=${$(
            '#ddlType'
        ).val()}&year=${$('#ddlSeason').val()}&team=${$(
            '#ddlTeamId'
        ).val()}&sort=${$('#sort').val()}&sortDir=${$('#sortDir').val()}`
        window.history.pushState('', '', url)
        return url
    }
})
